<template>
  <span>
    <svg-icon icon="users-2" class="icon-lg" />
    <span>{{ participants }} {{ $tc('participant', participants) }}</span>
  </span>
</template>

<script>
export default {
  props: {
    participants: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  display: flex;
  align-items: center;
  color: $light;
  font-size: 0.875rem;

  span,
  i {
    display: inline-block;
    vertical-align: middle;
  }

  i {
    position: relative;
    top: 0;
    margin-right: 0.25rem;
    color: $light;
  }
}
</style>
